import { isPlanFutureStart } from './is-plan-future-start';
import { BenefitPlanListContract } from '../types/contracts';

export const isBenefitPlanActive = (plan: BenefitPlanListContract): boolean => {
    return plan.active || isPlanFutureStart(plan) || (plan.isDraft && !plan.startDate);
};
